import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Lesson } from '../models';
import { PaginationParams } from '../types';

export const lessonsActions = createActionGroup({
    source: 'Lessons',
    events: {
        'Get Lessons': props<{ value: PaginationParams }>(),
        'Get Lessons Success': props<{ payload: Lesson[]; total: number }>(),
        'Get Lessons Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
